import { createStore } from 'zustand'

import {
  BLOCK_TYPE_LIST,
  BLOCK_TYPE_SHORTCUT_MAP,
  FONT_FAMILY_LIST,
  FONT_SIZE_LIST,
  LINE_HEIGHT_LIST
} from './constants'
import { RichEditorOptions, RichEditorStore } from './interface'

export const createRichEditorStore = ({
  previewFileRef,
  defaultFontFamily,
  defaultFontSize,
  defaultFontColor,
  defaultFontBackgroundColor,
  defaultLineHeight
}: RichEditorOptions) =>
  createStore<RichEditorStore>((set, get) => ({
    previewFileRef,
    blockTypeList: BLOCK_TYPE_LIST,
    blockTypeShortcuts: BLOCK_TYPE_SHORTCUT_MAP,
    fontFamilyList: FONT_FAMILY_LIST,
    defaultFontFamily,
    currentFontFamily: defaultFontFamily,
    setCurrentFontFamily(fontFamily) {
      set({
        currentFontFamily: fontFamily || defaultFontFamily
      })
    },
    fontSizeList: FONT_SIZE_LIST,
    defaultFontSize,
    currentFontSize: defaultFontSize,
    setCurrentFontSize(size) {
      set({
        currentFontSize: size
      })
    },
    defaultFontColor,
    currentFontColor: defaultFontColor,
    setCurrentFontColor(color) {
      set({
        currentFontColor: color
      })
    },
    defaultFontBackgroundColor,
    currentFontBackgroundColor: defaultFontBackgroundColor,
    setCurrentFontBackgroundColor(color) {
      set({
        currentFontBackgroundColor: color
      })
    },
    lineHeightList: LINE_HEIGHT_LIST,
    defaultLineHeight,
    currentLineHeight: defaultLineHeight,
    setCurrentLineHeight(lineHeight) {
      set({
        currentLineHeight: lineHeight
      })
    }
  }))
